import { Env } from "../env.type";

const env: Env = {
  host: "http://localhost:3005",
  nameAplication: "Sistema de gestão do programa Padrinho Veterano & Angels",
  initialsApplication: "PV",
  env: "local",
  brand: "yduqs",
  api: "http://localhost:3000",
  apm: "",
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID!,
    authority: process.env.REACT_APP_AUTHORITY!,
    scopes: [`${process.env.REACT_APP_CLIENT_ID!}/.default`],
  },
};

export default env;
